module.exports = __webpack_public_path__ + "static/media/logo.935aea32.svg";